import "../../../../styles/productView.scss";
import "../../../../styles/productViewListItem.scss";

import {Tab, TabList, TabPanel, Tabs} from "../../../common/components/Tabs.jsx";

import CounterField from "../../../common/components/CounterField.jsx";
import { Localization } from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import Scroll from "../../../common/components/Scroll.jsx";


/**
 * Component for a single product row in the template list (counterfield that increases qty)
 */
export class FreshFoodProductListMobileItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onEdit = this.onEdit.bind(this);
        this.validateNewQty = this.validateNewQty.bind(this);
        this.checkDisabledDay = this.checkDisabledDay.bind(this); 
    }

    onEdit(change) {
        const {
            updateTemplateQty,
            product,
            templateData,
            propName,
        } = this.props;

        const changeObj = { [propName] : change.value };
        updateTemplateQty(changeObj, product, templateData.hubId);
    }

    validateNewQty() {
        return true;
    }

    checkDisabledDay(weekDay, thisweek, nextWeek)
    {
        const {
            templateData,
        } = this.props;

        const daysToCheck = thisweek ? templateData.disabledDaysThisWeek : nextWeek ? templateData.disabledDaysNextWeek : templateData.disabledDaysTemplate;
        
        return daysToCheck.some(d => d === weekDay);
    }

    render() {
        const {
            product,
            thisWeek,
            nextWeek,
            weekday,
            qty,
            localization,
        } = this.props;

        return (
            <div className="product-view-list-item-wrapper not-interactive" draggable={false}>
                <div className="container">
                    <div className="list">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={8}>
                                <div className="product-view-list-item-tiny">
                                    <div className={"product-view-list-item-image-background"}>
                                        {product.imageUrl && (
                                            <React.Fragment>
                                                <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div style={{flexGrow:"1"}}>
                                        <div className="label14 prd-name" >
                                            {product.productName}
                                        </div>
                                        <div className="prd-info">
                                            <div className="label10 prd-size">
                                                { localization.text("order","packSize",{noOfSalesUnits:product.noOfSalesUnits})}
                                            </div>
                                            <div className={`label16 prd-price ${product.campaignDiscount ? "prd-price-campaign" : ""}`}>
                                                { product.price ? product.price.toFixed(2) : "" }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={4}>
                                <div className="product-view-list-item-counter-field">
                                    <CounterField  onEdit={this.onEdit} value={qty} border={false} invisibleBackground={true} alwaysShowInputField={true} minValue={0} disabled={this.checkDisabledDay(weekday, thisWeek, nextWeek)}/>                                   
                                </div>
                            </ResponsiveColumn>                          
                        </ResponsiveRows>
                    </div>
                </div>
            </div>
        );
    }
}

FreshFoodProductListMobileItem.propTypes = {
    localization: Localization.propTypes.isRequired,
    product: PropTypes.object,
    thisWeek: PropTypes.bool.isRequired,
    nextWeek: PropTypes.bool.isRequired,
    updateTemplateQty : PropTypes.func.isRequired,
    templateData : PropTypes.object.isRequired,
    weekday: PropTypes.string.isRequired,
    qty: PropTypes.number.isRequired,
    propName: PropTypes.number.isRequired,
};

FreshFoodProductListMobileItem.defaultProps = {
};

/**
 * Displays the template product list for small devices each day is edited separately.
 */
class FreshFoodProductListMobile extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            width: null,
        };
        this.containerNode = null;

        //this.trackScrolling = this.trackScrolling.bind(this);
        this.prepareItems = this.prepareItems.bind(this);
    }

    prepareItems(weekday, height, style) {
        const {
            list,
            localization,
            setModal,
            thisWeek,
            nextWeek,
            updateTemplateQty,
            templateData,
        } = this.props;

        const retNodes = [];

        for (let i = 0; i < list.length; i++) {
            const product = list[i];
            const propName = thisWeek ? "OrderedQtyCurrentWeek" : nextWeek ? "OrderedQtyNextWeek" : "TemplateQty";
            const fullPropName = `${weekday}${propName}`;
            const qty = product[fullPropName];

            retNodes[retNodes.length] = (
                <FreshFoodProductListMobileItem
                    key={i}
                    localization={localization}
                    product={list[i]}
                    setModal={setModal}
                    thisWeek={thisWeek}
                    nextWeek={nextWeek}
                    updateTemplateQty={updateTemplateQty}
                    templateData={templateData}
                    weekday={weekday}
                    qty={qty}
                    propName={fullPropName}
                />);
        }

        const scrollNode =  
        (<Scroll  style={{ height: height - 70, ...style }} className={"product-view-items-wrapper"} onCloseToBottom={this.trackScrolling} shadowStyle={{ borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }}>
            {retNodes}
        </Scroll>);

        return scrollNode;
    }

    render() {
        const {
            height,
            style,
        } = this.props;

        return (
            <React.Fragment>
                <Tabs startTabId={"1"}>
                    <TabList >
                        <Tab id={"1"} label={"Man"} small={true} />
                        <Tab id={"2"} label={"Tir"} small={true}/>
                        <Tab id={"3"} label={"Ons"} small={true}/>
                        <Tab id={"4"} label={"Tor"} small={true}/>
                        <Tab id={"5"} label={"Fre"} small={true}/>
                        <Tab id={"6"} label={"Lør"} small={true}/>
                        <Tab id={"7"} label={"Søn"} small={true}/>
                    </TabList>
                    <TabPanel key={1}>
                        { this.prepareItems("monday", height, style) }
                    </TabPanel>
                    <TabPanel key={2}>
                        { this.prepareItems("tuesday", height, style) }
                    </TabPanel>
                    <TabPanel key={3}>
                        { this.prepareItems("wednesday", height, style) }
                    </TabPanel>
                    <TabPanel key={4}>
                        { this.prepareItems("thursday", height, style) }
                    </TabPanel>
                    <TabPanel key={5}>
                        { this.prepareItems("friday", height, style) } 
                    </TabPanel>
                    <TabPanel key={6}>
                        { this.prepareItems("saturday", height, style) }
                    </TabPanel>
                    <TabPanel key={7}>
                        { this.prepareItems("sunday", height, style) }
                    </TabPanel>
                </Tabs>
            </React.Fragment>
        );
    }
}

FreshFoodProductListMobile.propTypes = {
    height: PropTypes.number,
    // If true a loading icon will be displayed
    isLoading: PropTypes.bool,
    // An array of products to be displayed
    list: PropTypes.array.isRequired,
    setModal: PropTypes.func.isRequired,
    style: PropTypes.object,
    thisWeek: PropTypes.bool.isRequired,
    nextWeek: PropTypes.bool.isRequired,
    template: PropTypes.bool.isRequired,
    updateTemplateQty : PropTypes.func.isRequired,
    templateData : PropTypes.object.isRequired,
    localization: Localization.propTypes.isRequired,
};

export default FreshFoodProductListMobile;
